<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4eVQ0b/tc-custom/9781439673010.jpg?1704586003239" alt="This image is the cover for the book A History Lover's Guide to Omaha"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A History Lover's Guide to Omaha
      </h1>
      <p class="bookDescription body article font2">
        <p>In Omaha, an evening stroll can provide passage into a fascinating past. Travel from a madam's elaborate grave in North Omaha to the site of the first U.S. airmail flight in Aksarben. Chase down the echoes of a Duke Ellington performance at the Dreamland Ballroom in the Jewell Building. Stow away on a tour that treats the whole city like a museum. Colorful street murals and Gilded Age mansions stand in as exhibits alongside the more traditional offerings of state markers and archival collections. Gain fresh appreciation for familiar landscapes and famous landmarks as Eileen Wirth and Carol McCabe move through Omaha neighborhood by neighborhood.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eileen Wirth, Carol McCabe
      </h2>
      
      <p class="authorDescription body article">Dr. Eileen Wirth is a professor emeritus of journalism at Creighton University and is an author specializing in Omaha history. Her books include <I>The Henry Doorly Zoo & Aquarium</I>, <I>Historic Omaha Houses of Worship</I> and <I>From Society Page to Front Page</I>. She is on the board of History Nebraska and is a member of the Nebraska Journalism Hall of Fame, the Nebraska Women's Journalism Hall of Fame and the Omaha Press Club Hall of Fame. She also has been active in numerous groups, particularly the Omaha Public Library.<br><br>Carol McCabe has worked in all areas of photography, including owning a traditional photo lab, running a photography gallery in Omaha's Old Market district, working in photographic archives and serving as photo editor for various publications.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d5a3cf3e